import { permissions, providerAdminRoleName } from 'constants/permissions';
import useCheckPermission from './useCheckPermission';
import { useGetProjectQuery } from 'store/userOrg/enhancedUserOrgApi';
import { useGetApiAdministrationProjectQuery } from 'store/userOrg/enhancedUserOrgAdministrationApi';

export interface UseGetProjectDataParams {
    projectShortName?: string;
    domainId?: string;
    startDate?: string;
    endDate?: string;
}

export const useGetProjectData = ({ projectShortName, domainId, startDate, endDate }: UseGetProjectDataParams) => {
    const checkPerms = useCheckPermission();
    const isPlatformAdmin = checkPerms(permissions.platformadmin, '');
    const isProviderAdmin = checkPerms(providerAdminRoleName, '');
    const isAdmin = isPlatformAdmin || isProviderAdmin;

    const standardQuery = useGetProjectQuery(
        { projectShortName },
        {
            skip: isAdmin,
        }
    );

    const adminQuery = useGetApiAdministrationProjectQuery(
        {
            projectShortName,
            domainId,
            startDate,
            endDate,
        },
        {
            skip: !isAdmin,
        }
    );

    return isAdmin ? adminQuery : standardQuery;
};
